export default "__VITE_ASSET__DRIpk$ZT__"